import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavStateService {
    private _paths = new BehaviorSubject<string[]>([]);
    readonly paths$ = this._paths.asObservable();

    private _navbarPaths = new BehaviorSubject<string[]>([]);
    readonly navbarPaths$ = this._navbarPaths.asObservable();

    setPaths(paths: string[]): void {
        this._paths.next(paths);
    }

    hasPath(path: string): boolean {
        return this._paths.value.includes(path);
    }

    setNavbarPaths(paths: string[]): void {
        this._navbarPaths.next(paths);
    }

    hasNavbarPath(path: string): boolean {
        return this._navbarPaths.value.includes(path);
    }
}
